module.exports = __webpack_public_path__ + "img/Readdit_Screenshot.5340388a.png";